// todos actions
export const ADD_TODO = 'ADD_TODO'
export const DELETE_TODO = 'DELETE_TODO'
export const UPDATE_TODO = 'UPDATE_TODO'
export const COMPLETE_TODO = 'COMPLETE_TODO'

export const LOADING_TODOS = 'LOADING_TODOS'
export const STOP_LOADING_TODOS = 'STOP_LOADING_TODOS'

// todo lists actions
export const GET_LISTS = 'GET_LISTS'
export const ADD_LIST = 'ADD_LIST'
export const DELETE_LIST = 'DELETE_LIST'

export const LOADING_LISTS = 'LOADING_LISTS'
export const STOP_LOADING_LISTS = 'STOP_LOADING_LISTS'

// errors actions 
export const SET_ERRORS = 'SET_ERRORS'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'

// auth actions
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'

export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAIL = 'REGISTER_FAIL'

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'

export const USER_LOADING = 'USER_LOADING'
export const USER_LOADED = 'USER_LOADED'
export const AUTH_ERROR = 'AUTH_ERROR'